import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {GroupsPage} from "../groups/groups";

@Component({
  selector: 'page-group-add',
  templateUrl: 'group-add.html'
})
export class GroupAddPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToGroups(params){
    if (!params) params = {};
    this.navCtrl.push(GroupsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/group-add/group-add.ts